import React, { useMemo } from 'react'
import { checkIfOutOfStockByStockMessage } from '@helpers/product'
import { any, bool, string } from 'prop-types'
import { Stack, Typography, styled, css } from '@mui/material'

const AddToCartStockMessageStyled = styled(Stack)(
  ({ theme }) => css`
    h3 {
      font-size: 23px;
      margin-left: 7px;
      color: ${theme.palette.error.main};
    }
    h4 {
      font-size: 16px;
      margin-left: 7px;
      color: ${theme.palette.error.main};
    }
  `,
)

const ReachedCartLimit = ({ heading, message }) => (
  <>
    <Typography variant="h3">{heading}</Typography>
    <Typography variant="h4">{message}</Typography>
  </>
)

ReachedCartLimit.propTypes = {
  heading: string,
  message: string,
}

const AddToCartStockMessage = ({ stockMessage, includesRequiredAddon, reachedCartLimit, reachedGiftCardMaxPrice }) => {
  const unableToAdd = 'Unable to add to cart'
  const cartLimit = 'You have already added 10 of this item to your cart.'
  const giftCardMaximumPrice = 'You can only add up to $2000 of Gift Cards in your cart.'
  const isOutOfStock = useMemo(() => checkIfOutOfStockByStockMessage(stockMessage), [stockMessage])
  const outputMessage = isOutOfStock ? 'Product is currently out of stock.' : 'Product is not available in your region.'

  return (
    <AddToCartStockMessageStyled className="add-to-cart-stock-message">
      {!includesRequiredAddon &&
        !reachedCartLimit &&
        !reachedGiftCardMaxPrice &&
        (stockMessage === 'Out of Stock ' ||
          stockMessage === 'Not available in your region ' ||
          stockMessage === 'Discontinued ' ||
          stockMessage === 'Available Soon ') && (
          <>
            <Typography variant="h3">{unableToAdd}</Typography>
            {outputMessage && <Typography variant="h4">{outputMessage}</Typography>}
          </>
        )}
      {reachedCartLimit && <ReachedCartLimit heading={unableToAdd} message={cartLimit} />}
      {reachedGiftCardMaxPrice && <ReachedCartLimit heading={unableToAdd} message={giftCardMaximumPrice} />}
    </AddToCartStockMessageStyled>
  )
}

AddToCartStockMessage.propTypes = {
  stockMessage: any,
  includesRequiredAddon: bool,
  reachedCartLimit: bool,
  reachedGiftCardMaxPrice: bool,
}

export default AddToCartStockMessage
